import { render, staticRenderFns } from "./DLGTicketStatus.vue?vue&type=template&id=d8fefce8&"
import script from "./DLGTicketStatus.vue?vue&type=script&lang=js&"
export * from "./DLGTicketStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8fefce8')) {
      api.createRecord('d8fefce8', component.options)
    } else {
      api.reload('d8fefce8', component.options)
    }
    module.hot.accept("./DLGTicketStatus.vue?vue&type=template&id=d8fefce8&", function () {
      api.rerender('d8fefce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticket/DLGTicketStatus.vue"
export default component.exports